<template>
    <div>
        <div v-if="fileObject">
            <div class="d-inline-block">
                <i class="fa fa-3x fa-file-pdf-o" style="color: var(--primary-to-yellow);"></i>
            </div>
            <div class="d-inline-block ml-2">
                <div>
                    <span>{{fileObject.filename}}</span>
                </div>
                <div>
                    <a target="_blank" class="mr-3"
                       :href="route_show_file+'/'+fileObject.hash+'?filename='+fileObject.filename">{{ $lang('Podgląd') }}</a>
                    <a class="mr-3" href="#" data-toggle="modal"
                       data-target="#delete_modal"
                       v-if="can_edit"
                    >{{ $lang('Usuń') }}</a>
                </div>
            </div>
        </div>
        <div v-else-if="!fileObject && can_edit">
            <input type="hidden" name="has_new_attachment" :value="true"></input>
            <dropzone :route_store="route_store_attachment"
                      :route_delete="route_delete_attachment"
                      :editable="true"
                      :max_files="1"
                      :accepted_files="'application/pdf'">
            </dropzone>
        </div>

        <div class="modal fade" id="delete_modal" tabindex="-1" v-if="fileObject">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $lang('Usunięcie pliku') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        {{ $lang('Czy na pewno chcesz usunąć plik?') }}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default"
                                data-dismiss="modal">{{ $lang('Nie') }}
                        </button>
                        <button class="btn btn-primary" v-on:click="deleteFile" data-dismiss="modal">
                            {{ $lang('Tak') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Dropzone from "./dropzone";
import AttachmentTable from "./task/attachment-table";
import ShowNotification from "../mixins/show-notification";

export default {
    name: "single-file-component",
    components: {Dropzone, AttachmentTable},
    mixins: [ShowNotification],
    props: {
        file: {type: Array|Object, required: true},
        route_delete_file: {type: String, required: true},
        route_show_file: {type: String, required: true},
        route_store_attachment: {type: String, required: true},
        route_delete_attachment: {type: String, required: true},
        can_edit: {type: Boolean, required: true},
        object_id: {type: Number|null, required: false, default: null}
    },
    data() {
        return {
            fileObject: this.file,
        }
    },
    methods: {
        deleteFile() {
            const self = this;
            let data = {};
            data.hash = this.fileObject.hash;
            data.objectId = this.object_id;
            axios.delete(this.route_delete_file, {data})
                .then(function () {
                    self.fileObject = null;
                })
                .catch(function (error) {
                    self.showNotification('error', 'Nie udało się usunąć pliku!');
                });
        },
    },
}
</script>
